import React from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";


import {Card, List, Space, Typography} from "antd";

import {
    BorderInnerOutlined,
    ExportOutlined,
    LeftOutlined,
    MoneyCollectOutlined,
    SettingOutlined, UngroupOutlined,
    UploadOutlined,
    WechatWorkOutlined
} from "@ant-design/icons";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom"

function AdminSettingDashboardPage(props) {

    const settingLinks = [
        {
            title: "تنظیمات مرکز آموزشی",
            icon: <SettingOutlined/>,
            href: URLS.admin.setting.academy,
        },
        {
            title: "تنظیمات سیستم",
            icon: <SettingOutlined/>,
            href: URLS.admin.setting.system,
        },
        {
            title: "گروه‌های علمی",
            icon: <UngroupOutlined />,
            href: URLS.admin.group.list,
        },
        {
            title: "مقاطع تحصیلی",
            icon: <BorderInnerOutlined />,
            href: URLS.admin.grade.list,
        },
        {
            title: "سوابق ارسال پیامک",
            icon: <WechatWorkOutlined/>,
            href: URLS.admin.setting.sms,
        },
        {
            title: "تنظیمات بازگشت وجه",
            icon: <MoneyCollectOutlined/>,
            href: URLS.admin.setting.refund,
        },
        {
            title: "وارد سازی داده انبوه",
            icon: <UploadOutlined/>,
            href: URLS.admin.import.dashboard,
        },
        {
            title: "دریافت خروجی از اطلاعات",
            icon: <ExportOutlined/>,
            href: URLS.admin.exports.dashboard,
        },

    ];


    return (
        <AdminLayout pageTitle={'تنظیمات'} backTo={URLS.admin.dashboard}>


            <Card
                title={
                    <Space>
                        <SettingOutlined/>
                        <span>دسترسی سریع</span>
                    </Space>
                }
            >
                <List
                    dataSource={settingLinks}
                    renderItem={(item) => (
                        <List.Item>
                            <Link
                                to={item.href}
                                style={{
                                    width: "100%",
                                    color: "inherit",
                                }}
                            >
                                <Space
                                    style={{
                                        width: "100%",
                                        justifyContent:
                                            "space-between",
                                    }}
                                >
                                    <Space>
                                        {item.icon}
                                        <Typography.Text>
                                            {item.title}
                                        </Typography.Text>
                                    </Space>

                                    <LeftOutlined/>
                                </Space>
                            </Link>
                        </List.Item>
                    )}
                />
            </Card>

        </AdminLayout>
    );
}

export default AdminSettingDashboardPage;